import client from './client'

const getAllNodes = () => client.get('/api/nodelist')

const getSpecificNode = (name) => client.get(`/nodes/${name}`)

const getOptionsWhenLoadOptionsRefreshsOn = (nodeName, methodName, body) =>
    client.post(`/node-load-async-method/${nodeName}/${methodName}`, body)

export default {
    getAllNodes,
    getSpecificNode,
    getOptionsWhenLoadOptionsRefreshsOn
}
